'use strict';

var _ = require('lodash');
var ChartFBCFactory = function ChartFBCFactory(AbstractChart, scalesService, chartGroups, chartStripes, chartXAxis, chartYAxis, chartSimpleBars, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);

    // chart components
    var groups = chartGroups('code', formatters.tooltipFormatter, true);
    var stripes = chartStripes('data');
    var bars = chartSimpleBars('patternBarY');
    var xAxisTickValuesHandler = function xAxisTickValuesHandler(data) {
      return _.map(data, 'code');
    };
    var xAxis = chartXAxis(formatters.xAxisTickFormatter, xAxisTickValuesHandler);
    xAxis.withTextRotation({
      x: -5,
      y: 0,
      dy: '1.35em',
      transform: 'rotate(-25)'
    });
    var yAxis = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.RIGHT).label('Traffic').withLabelRotation(-90);
    this.render = function (data) {
      this.initChart(data, undefined, chartParams(data.length));
      this.scales = chartScales(this.params, this.data);
      this.callForDataGroup([yAxis, groups, stripes, xAxis, bars], this.scales);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartFBCFactory.$inject = ['AbstractChart', 'ScalesService', 'ChartElementsGroup', 'ChartElementsStripes', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsSimpleBars', 'ChartElementsConstants'];
module.exports = ChartFBCFactory;